import { render, staticRenderFns } from "./DeliveryInfoFormDesktop.vue?vue&type=template&id=57793632&scoped=true&"
import script from "./DeliveryInfoFormDesktop.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfoFormDesktop.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfoFormDesktop.vue?vue&type=style&index=0&id=57793632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57793632",
  null
  
)

export default component.exports